import { defineSlotRecipe } from '@chakra-ui/react';

// v2's FormErrorMessage / FormHelperText, which v3 merged into Field and
// restyled: 14px -> 12px, error weight 400 -> 500, and v2's 8px label `mb` /
// error `mt` replaced by a single 6px flex gap on root. Colours stay with the
// stock recipe's fg.error / fg.muted, which resolve again now cssVarsRoot is
// gone.
const fieldSlotRecipe = defineSlotRecipe({
  slots: ['root', 'label', 'requiredIndicator', 'helperText', 'errorText'],
  base: {
    root: { gap: '2' },
    // v2's FormLabel: fontSize md with the inherited 1.5 line-height, block
    // layout (no gap); its RequiredIndicator carried marginStart 1. Stock v3's
    // label is textStyle sm (14px) with a flex gap of 1.
    label: { fontSize: 'md', lineHeight: 'base', gap: 0 },
    requiredIndicator: { ms: 1 },
    errorText: { textStyle: 'sm', fontWeight: 'normal' },
    helperText: { textStyle: 'sm' },
  },
});

export default fieldSlotRecipe;
